import { StyleSheet } from "react-native";
import theme from "../theme";
import { dynamicSize, hexToRgba } from "../helpers";

export default StyleSheet.create({
	searchField: {
		width: dynamicSize(230),
		height: dynamicSize(24),
		backgroundColor: theme.colors.grey1,
		borderRadius: 6,
		paddingLeft: dynamicSize(30),
		color: theme.colors.white,
		paddingVertical: 0,
	},
	searchIcon: {
		width: dynamicSize(12),
		height: dynamicSize(12),
		position: "absolute",
		top: dynamicSize(6),
		left: dynamicSize(8),
		zIndex: 1,
	},
	filterIcon: {
		width: dynamicSize(18),
		height: dynamicSize(18),
		marginLeft: dynamicSize(10),
	},
	simplePickerButtonView: {
		width: "100%",
		padding: 8,
		borderTopWidth: 0.5,
		borderTopColor: "lightgrey",
		justifyContent: "space-between",
		flexDirection: "row",
		backgroundColor: theme.colors.grey10,
		shadowColor: theme.colors.black,
		shadowOpacity: 0.3,
		shadowRadius: 0,
		shadowOffset: { width: 0, height: -5 },
	},
	listItem: {
		shadowColor: theme.colors.black,
		shadowOpacity: 0.2,
		shadowRadius: 5,
		shadowOffset: { width: 0, height: 14 },
	},
	listItemImageWrapper: {
		width: "100%",
		height: dynamicSize(250),
		borderTopLeftRadius: 6,
		borderTopRightRadius: 6,
		overflow: "hidden",
	},
	image: {
		width: "100%",
		height: "100%",
		resizeMode: "cover",
	},
	honoruBadge: {
		width: dynamicSize(25),
		height: dynamicSize(31),
		marginRight: dynamicSize(10),
	},
	honoruBadgeSmall: {
		width: dynamicSize(20),
		height: dynamicSize(25),
		marginBottom: dynamicSize(3),
	},
	listItemInfo: {
		paddingHorizontal: dynamicSize(11),
		paddingTop: dynamicSize(6),
		paddingBottom: dynamicSize(8),
		borderBottomLeftRadius: 6,
		borderBottomRightRadius: 6,
		backgroundColor: theme.colors.grey3,
	},
	listItemLink: {
		height: dynamicSize(24),
		// textAlign: 'right'
	},
	closeIcon: {
		width: dynamicSize(22),
		height: dynamicSize(22),
		marginRight: dynamicSize(8),
	},
	subBarButton: {
		width: dynamicSize(25),
		height: dynamicSize(25),
		alignItems: "center",
		justifyContent: "flex-end",
	},
	slider1: {
		height: dynamicSize(290),
	},
	slider2: {
		flex: 1,
	},
	sliderPaginationWrapper: {
		position: "absolute",
		bottom: 12,
		width: "100%",
		alignItems: "center",
	},
	sliderPagination: {
		backgroundColor: hexToRgba(theme.colors.lightBlack, 0.5),
		width: dynamicSize(80),
		height: dynamicSize(24),
		borderRadius: dynamicSize(3),
	},
	sliderPaginationText: {
		textAlign: "center",
	},
	slide: {
		flex: 1,
		justifyContent: "center",
		backgroundColor: "transparent",
	},
	image2: {
		width: "100%",
		// height: dynamicSize(280),
		height: "100%",
		resizeMode: "cover",
		marginBottom: dynamicSize(50),
	},
	contactBlock: {
		height: dynamicSize(78),
		paddingHorizontal: dynamicSize(23),
		paddingVertical: dynamicSize(10),
		backgroundColor: theme.colors.grey3,
		shadowColor: theme.colors.black,
		shadowOpacity: 0.33,
		shadowOffset: { width: 0, height: -2 },
		shadowRadius: 2,
	},
	divider: {
		height: dynamicSize(30),
		justifyContent: "center",
	},
	sellerBlock: {
		paddingVertical: dynamicSize(10),
		flexDirection: "row",
		alignItems: "center",
	},
	sellerImageWrapper: {
		width: dynamicSize(75),
		height: dynamicSize(75),
		overflow: "hidden",
		borderRadius: dynamicSize(37.5),
		marginRight: dynamicSize(18),
	},
	contactWindow: {
		position: "absolute",
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,
		justifyContent: "center",
		paddingHorizontal: dynamicSize(64),
		zIndex: 1,
		backgroundColor: hexToRgba(theme.colors.black, 0.83),
	},
	contactWindowHeader: {
		marginBottom: dynamicSize(48),
		alignItems: "center",
	},
	contactWindowListItem: {
		marginBottom: dynamicSize(38),
		flexDirection: "row",
		alignItems: "center",
	},
	contactWindowListItemIcon: {
		width: dynamicSize(56),
		height: dynamicSize(56),
	},
	contactWindowClose: {
		position: "absolute",
		left: dynamicSize(15),
		top: dynamicSize(11),
	},
	contactWindowCloseIcon: {
		width: dynamicSize(22),
		height: dynamicSize(22),
	},
	orderArrowIcon: {
		width: dynamicSize(10),
		height: dynamicSize(10),
		marginLeft: dynamicSize(10),
		resizeMode: "contain",
	},
	modalContainer: {
		flex: 1,
		width: null,
		height: null,
		backgroundColor: theme.colors.grey2,
	},
	addNewButton: {
		width: dynamicSize(50),
		height: dynamicSize(50),
		backgroundColor: theme.colors.black,
		borderRadius: dynamicSize(25),
		justifyContent: "center",
		alignItems: "center",
		shadowColor: theme.colors.black,
		shadowOpacity: 0.7,
		shadowOffset: { width: 4, height: 4 },
		shadowRadius: 4,
		position: "absolute",
		bottom: dynamicSize(16),
		right: dynamicSize(16),
	},
	addNewIcon: {
		width: dynamicSize(22),
		height: dynamicSize(22),
		resizeMode: "cover",
	},
	addImageButton: {
		flexDirection: "row",
		alignItems: "center",
		height: dynamicSize(20),
	},
	addImageIcon: {
		width: dynamicSize(12),
		height: dynamicSize(12),
		resizeMode: "cover",
		marginRight: dynamicSize(5),
	},
	removeImageButton: {
		position: "relative",
		height: dynamicSize(180),
		marginTop: dynamicSize(20),
		paddingHorizontal: dynamicSize(10),
	},
	removeImageIcon: {
		position: "absolute",
		right: 0,
		top: -dynamicSize(10),
		width: dynamicSize(20),
		height: dynamicSize(20),
		backgroundColor: theme.colors.white,
		borderRadius: dynamicSize(10),
		justifyContent: "center",
		alignItems: "center",
	},
});
